import React from "react";
import {
  HeroContainer,
  HeroLeftContainer,
  Img,
  HeroRightContainer,
  HeroInnerContainer,
  TextLoop,
  Title,
  Span,
  SubTitle,
  ResumeButton,
  GhostButton,
  ButtonRow,
  Meta,
  PortraitFrame,
  Ring,
  RingInner,
  TickerWrap,
  TickerTrack,
} from "./HeroStyle";
import HeroImg from "../../images/Profile_pic.jpeg";
import Typewriter from "typewriter-effect";
import { Bio, skills } from "../../data/constants";

const tickerSkills = skills.flatMap((group) => group.skills.map((item) => item.name));

const HeroSection = () => {
  const loop = [...tickerSkills, ...tickerSkills];

  return (
    <HeroContainer id="about">
      <div style={{ width: "100%", maxWidth: 1120 }}>
        <HeroInnerContainer>
          <HeroLeftContainer>
            <Title>
              {Bio.name.split(" ")[0]}
              <br />
              {Bio.name.split(" ")[1]}
            </Title>
            <TextLoop>
              I build as a
              <Span>
                <Typewriter
                  options={{
                    strings: Bio.roles,
                    autoStart: true,
                    loop: true,
                  }}
                />
              </Span>
            </TextLoop>
            <SubTitle>{Bio.description}</SubTitle>
            <ButtonRow>
              <ResumeButton href={Bio.resume} target="_blank" rel="noreferrer">
                View resume
              </ResumeButton>
              <GhostButton href={Bio.linkedin} target="_blank" rel="noreferrer">
                LinkedIn
              </GhostButton>
              <GhostButton href={Bio.github} target="_blank" rel="noreferrer">
                GitHub
              </GhostButton>
            </ButtonRow>
            <Meta>
              <a href={`mailto:${Bio.email}`}>{Bio.email}</a>
              <a href={`tel:${Bio.phone.replace(/\s/g, "")}`}>{Bio.phone}</a>
            </Meta>
          </HeroLeftContainer>

          <HeroRightContainer>
            <PortraitFrame>
              <Ring />
              <RingInner />
              <Img src={HeroImg} alt="Vishwas Jain" />
            </PortraitFrame>
          </HeroRightContainer>
        </HeroInnerContainer>

        <TickerWrap>
          <TickerTrack>
            {loop.map((name, index) => (
              <span key={`${name}-${index}`}>{name}</span>
            ))}
          </TickerTrack>
        </TickerWrap>
      </div>
    </HeroContainer>
  );
};

export default HeroSection;
